<template>
  <div class="page-device" :style="{ height: pageHeight + 'px' }">
    <div class="real-time">
      <div class="option-box">
        <el-input style="max-width: 120px; margin-right: 20px" placeholder="雷达SN" v-model="searchSn"></el-input>
        <el-input style="max-width: 120px; margin-right: 20px" placeholder="数据标识" v-model="uuid"></el-input>
        <el-select v-model="pushObj" placeholder="选择推送对象">
          <el-option v-for="item in pushObjList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="pushState" placeholder="选择推送状态">
          <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker type="date" v-model="pushDate" placeholder="请选择推送日期" style="width: 160px; margin-right: 10px"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
        <el-button class="option-btn" @click="reset">重置</el-button>
        <el-button class="option-btn" @click="filterDevice">筛选</el-button>
      </div>
      <div class="monitor-info-title">
        <div>推送对象</div>
        <div>数据标识</div>
        <div>雷达SN</div>
        <div>状态</div>
        <div>推送时间</div>
        <div>完成时间</div>
      </div>
      <el-scrollbar style="height: 100%">
        <div class="list-box" v-loading="isLoading">
          <div class="monitor-info" :style="{ background: index % 2 == 0 ? '#efefef' : '' }"
            v-for="(item, index) in deviceList" :key="'showDevice' + index">
            <div>{{ item.pushObjName }}</div>
            <div>{{ item.uuid }}</div>
            <div>{{ item.sn }}</div>
            <div>{{ item.state == '1' ? '已推送' : item.state == '2' ? '已完成' : '未知' }}</div>
            <div>{{ item.pushDate }}</div>
            <div>{{ item.replyDate }}</div>
          </div>
        </div>
      </el-scrollbar>
      <el-pagination :page-size="pageSize" :total="deviceTotal" @current-change="pageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import utils from "../../utils/utils";
import {
  getBuilding,
  getFloor,
  getRoom,
  getBed,
  getDevice,
  queryRadarType,
  addDevice,
  delDevice,
  pushLog,
} from "../../api/device";
import { getCompany } from "../../api/user";

let companyMap = new Map();
export default {
  name: "RealTime",
  data() {
    return {
      pushObj: '',
      pushObjList: [],
      pageHeight: 0,
      tower: "",
      floor: "",
      room: "",
      bed: "",
      device: "",
      towers: [],
      floors: [],
      rooms: [],
      devices: [],
      allDevices: [],
      deviceList: [],
      beds: [],
      allBeds: [],
      radarTypes: [],
      isBatch: true,

      updateImg: require("../../assets/images/system/deviceUpdate.svg"),
      isMask: false,
      monitorTime: "",
      radarIp: "",
      radarLifeImg: require("../../assets/images/system/radarLife.svg"),
      radarDownImg: require("../../assets/images/system/radarDown.svg"),
      closeImg: require("../../assets/images/system/close.svg"),

      deviceTitle: "",
      selectRadar: "",
      radarTypeList: [],
      radarIp: "",
      radarPort: "",
      radarSn: "",
      radarSetPort: "",

      updateRadarList: [],
      updateType: "",

      checkedList: [],

      isAddDelRadar: false,
      isLifeRadar: false,
      isDownRadar: false,
      startTime: "",
      endTime: "",

      drawer: false,
      radarForm: {},
      headers: {},
      deviceTotal: 0,
      currPage: 1,
      pageSize: 10,
      isLoading: false,
      isAllCheck: 0,
      searchSn: "",
      pushDate: null,
      uuid: '',
      pushState: '',
      stateList: [{
        label: '已推送',
        value: '1'
      }, {
        label: '已完成',
        value: '2'
      }],
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() >
            new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
            time.getTime() <
            new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).setHours(0, 0, 0, 0)
            ).getTime()
          );
        },
      },
    };
  },
  created() { },
  mounted() {
    this.initPageHeight();

    window.addEventListener("resize", this.initPageHeight, false);

    let token = localStorage.getItem("healthyToken");
    if (token) {
      this.headers.token = token;
    }

    this.getCompanys()
  },
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;
    },

    getCompanys() {
      companyMap.clear()
      getCompany().then(res => {
        let list = []
        if (res.data.length > 0) {
          res.data.forEach((item) => {
            let obj = {
              value: Number(item.id),
              label: item.company,
            };
            list.push(obj);
            companyMap.set(item.id, item)
          });
        }
        this.pushObjList = list;

        this.getPushLog();
      })
    },

    getPushLog() {
      this.isLoading = true
      let obj = {
        page: this.currPage,
        size: this.pageSize,
      }

      if (this.searchSn) {
        obj.sn = this.searchSn
      }

      if (this.uuid) {
        obj.uuid = this.uuid
      }

      if (this.pushState) {
        obj.state = this.pushState
      }

      if (this.pushDate) {
        obj.searchDate = this.pushDate
      }

      if (this.pushObj) {
        obj.pushObj = this.pushObj
      }
      pushLog(obj).then(res => {
        console.log('获取用户推送日志', res)
        this.isLoading = false
        this.deviceTotal = res.data.total;
        if (res.data.page.length > 0) {
          res.data.page.forEach(item => {
            item.pushDate = item.pushDate ? utils.formatTime(new Date(item.pushDate)) : '未知'
            item.replyDate = item.replyDate ? utils.formatTime(new Date(item.replyDate)) : '未知'

            try {
              item.pushObjName = companyMap.get(item.pushObj).company
            } catch (error) {
              item.pushObjName = item.pushObj
            }
          })
          this.deviceList = res.data.page
        } else {
          this.deviceList = []
        }
      }).catch(() => {
        this.isLoading = false;
        this.deviceList = []
      })
    },

    // 选择页码
    pageChange(e) {
      this.currPage = e;
      this.getPushLog();
    },

    filterDevice() {
      this.currPage = 1;
      this.getPushLog();
    },

    // 重置
    reset() {
      this.searchSn = "";
      this.uuid = '';
      this.pushDate = null
      this.pushState = ''
      this.currPage = 1;
      this.pushObj = ''
      this.getPushLog();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight, false);
    if (this.isMask) {
      this.back();
    }
    if (this.webSocket) {
      this.webSocket.close();
    }
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-device {
  width: 100%;
  height: 100%;
  padding: 20px;
  // padding: 70px 60px 60px 60px;
  // padding: 3vw 5.5vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .real-time {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 40px 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .option-box {
      display: flex;
      justify-content: center;

      .option-btn {
        width: 100px;
        height: 40px;
        font-size: 14px;
        color: #fff;
        background: #1d63fd;
        border-radius: 8px;
        border: none;
        // margin-right: 38px;
      }

      // .option-btn:nth-child(4) {
      //   width: 150px;
      //   margin-right: 0;
      // }
      // .option-btn:last-child {
      //   width: 150px;
      //   margin-right: 0;
      // }
    }

    .monitor-info-title {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 40px;

      div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // div:nth-child(1),
      // div:nth-child(2),
      // div:last-child {
      //   max-width: 100px;
      // }
      .check-box {
        width: 25px;
        height: 25px;
        box-sizing: border-box;
        border: 1px solid #c9d5ef;
        background: #fff;
        display: block;
      }

      .check-all-box {
        background: #1d63fd;
      }

      .check-half-box {
        border: 5px solid #c9d5ef;
        // border: 5px solid #fff;
        background: #1d63fd;
      }
    }

    .list-box {
      flex: 1;

      .monitor-info {
        height: 60px;
        display: flex;
        align-items: center;
        font-size: 15px;

        img {
          width: 30px;
          height: 30px;
        }

        div {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        // div:nth-child(1),
        // div:nth-child(2),
        // div:last-child {
        //   max-width: 100px;
        // }
        .check-box {
          width: 25px;
          height: 25px;
          box-sizing: border-box;
          border: 1px solid #c9d5ef;
          background: #fff;
          display: block;
        }

        .check-box-select {
          background: #1d63fd;
        }

        .radar-set-text {
          color: #f56c6c;
          cursor: pointer;
        }
      }
    }
  }

  .page-num-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;

    .page-num-list {
      height: 60px;
      display: flex;
      align-items: center;

      .page-num {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #26415f;
      }

      .page-num-active {
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #c9d5ef;
        border-radius: 8px;
      }
    }
  }
}

.drawer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .drawer-content {
    padding-right: 12px;
    flex: 1;
  }

  .drawer-footer {
    padding: 0 12px;
    height: 60px;
    box-sizing: border-box;
    border-top: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
<style>
.page-device .real-time .el-select {
  width: 150px;
  margin-right: 38px;
}

.el-input__inner {
  border-color: 1px solid#c9d5e7;
  border-radius: 8px;
}

.time-select .el-select {
  width: 100px;
  margin: 0 auto;
}

.time-select .el-input__inner {
  font-size: 13px;
}

.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/system/pushLog.vue